module.exports = __webpack_public_path__ + "img/arrowCity.363331e3.svg";